import { gql } from "apollo-boost"

export default gql`
  query Dashboard {
    cycleLicenseRequirements {
      cycleName
      yearlyHoursRequirement
      totalHoursRequirement
      startDate
      endDate
    }
    dashboardPage {
      calendarDaysText
      cycleDaysText
      cycleRangeText
      showCycleStats
      zeroStateBody
    }
    mostRecentCourses {
      id
      status
      course {
        id
        title
        courseType
        hours
        legalHours
        nonlegalHours
        fairhousingHours
        commission
        lessons {
          id
          order
        }
      }
      activeLesson {
        id
        order
      }
    }
  }
`
